'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpers = require('../../helpers');

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PelletStoveIcon = function PelletStoveIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement('path', {
                id: 'a',
                d: 'M14 101.796h74v-73.18H14z'
            })
        ),
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('circle', {
                fill: '#FDF6E3',
                opacity: '.8',
                cx: '65',
                cy: '65',
                r: '65'
            }),
            _react2.default.createElement(
                'g',
                {
                    transform: 'translate(15 14)'
                },
                _react2.default.createElement('path', {
                    fill: '#FFF',
                    d: 'M44.84.074v29.984H25.906v52.119h4.538l-.903 5.017v5.876h4.095V88.04l1.138-5.864H67.61l1.618 5.864v5.029h4.45V88.04l-1.863-5.864h4.576V29.532H57.689V.074z'
                }),
                _react2.default.createElement('path', {
                    fill: '#555',
                    d: 'M.972 94.88h100v-2h-100zM.972 100.138h100v-2h-100z'
                }),
                _react2.default.createElement('path', {
                    fill: '#555',
                    d: 'M30.278 93.066h-2.056l.017-5.228 1.085-5.987 2.023.372-1.07 5.893zM34.506 93.066h-2.055l.016-5.228 1.086-5.987 2.022.372-1.069 5.893zM74.13 93.066h-2.056v-4.95l-1.067-5.893 2.02-.372 1.103 6.173zM69.901 93.066h-2.055v-4.95l-1.068-5.893 2.021-.372 1.102 6.173zM37.639 69.974H64.36V51.258c0-4.504-3.641-8.167-8.118-8.167H45.757c-4.477 0-8.118 3.663-8.118 8.167v18.716zm28.778 2.068H35.583V51.258c0-5.644 4.564-10.235 10.174-10.235h10.486c5.61 0 10.174 4.591 10.174 10.235v20.784z'
                }),
                _react2.default.createElement(
                    'mask',
                    {
                        id: 'b',
                        fill: '#fff'
                    },
                    _react2.default.createElement('use', {
                        xlinkHref: '#a'
                    })
                ),
                _react2.default.createElement('path', {
                    fill: '#555',
                    mask: 'url(#b)',
                    d: 'M35.002 76.695h31.994v-2.068H35.002z'
                }),
                _react2.default.createElement('path', {
                    fill: '#555',
                    mask: 'url(#b)',
                    d: 'M77.38 83.07H25.648v-2.067h49.676v-50.32H26.676v42.132H24.62v-44.2h52.76z'
                }),
                _react2.default.createElement('path', {
                    fill: '#555',
                    mask: 'url(#b)',
                    d: 'M24.62 77.04h2.056v-2.758H24.62zM41.286 64.977a1.145 1.145 0 1 0 0 2.293c.628 0 1.139-.515 1.139-1.148 0-.631-.511-1.145-1.139-1.145m0 4.36c-1.762 0-3.195-1.442-3.195-3.215 0-1.771 1.433-3.213 3.195-3.213 1.761 0 3.195 1.442 3.195 3.213 0 1.773-1.434 3.215-3.195 3.215'
                }),
                _react2.default.createElement('path', {
                    d: 'M46.143 64.977c-.628 0-1.139.514-1.139 1.145 0 .633.511 1.147 1.139 1.147.627 0 1.14-.514 1.14-1.147 0-.631-.513-1.145-1.14-1.145m0 4.36c-1.761 0-3.194-1.442-3.194-3.215 0-1.771 1.433-3.213 3.194-3.213 1.762 0 3.196 1.442 3.196 3.213 0 1.773-1.434 3.215-3.196 3.215',
                    fill: '#555',
                    mask: 'url(#b)'
                }),
                _react2.default.createElement('path', {
                    d: 'M51 64.977a1.145 1.145 0 1 0 0 2.293c.628 0 1.14-.515 1.14-1.148 0-.631-.512-1.145-1.14-1.145m0 4.36c-1.762 0-3.196-1.442-3.196-3.215 0-1.771 1.434-3.213 3.196-3.213 1.762 0 3.196 1.442 3.196 3.213 0 1.773-1.434 3.215-3.196 3.215',
                    fill: '#555',
                    mask: 'url(#b)'
                }),
                _react2.default.createElement('path', {
                    d: 'M55.857 64.977a1.145 1.145 0 1 0 0 2.293c.628 0 1.139-.515 1.139-1.148 0-.631-.511-1.145-1.139-1.145m0 4.36c-1.762 0-3.196-1.442-3.196-3.215 0-1.771 1.434-3.213 3.196-3.213 1.761 0 3.194 1.442 3.194 3.213 0 1.773-1.433 3.215-3.194 3.215',
                    fill: '#555',
                    mask: 'url(#b)'
                }),
                _react2.default.createElement('path', {
                    d: 'M60.714 64.977c-.628 0-1.139.514-1.139 1.145 0 .633.511 1.147 1.139 1.147.627 0 1.14-.514 1.14-1.147 0-.631-.513-1.145-1.14-1.145m0 4.36c-1.761 0-3.195-1.442-3.195-3.215 0-1.771 1.434-3.213 3.195-3.213 1.762 0 3.195 1.442 3.195 3.213 0 1.773-1.433 3.215-3.195 3.215M51 60.5c-.628 0-1.14.514-1.14 1.146 0 .632.512 1.147 1.14 1.147.628 0 1.14-.515 1.14-1.147S51.628 60.5 51 60.5m0 4.36c-1.762 0-3.196-1.441-3.196-3.214 0-1.772 1.434-3.214 3.196-3.214 1.762 0 3.196 1.442 3.196 3.214 0 1.773-1.434 3.215-3.196 3.215',
                    fill: '#555',
                    mask: 'url(#b)'
                }),
                _react2.default.createElement('path', {
                    d: 'M56.108 60.5c-.628 0-1.14.514-1.14 1.146 0 .632.512 1.147 1.14 1.147.627 0 1.14-.515 1.14-1.147s-.513-1.146-1.14-1.146m0 4.36c-1.763 0-3.196-1.441-3.196-3.214 0-1.772 1.433-3.214 3.196-3.214 1.762 0 3.195 1.442 3.195 3.214 0 1.773-1.433 3.215-3.195 3.215M45.892 60.5c-.627 0-1.14.514-1.14 1.146 0 .632.513 1.147 1.14 1.147.628 0 1.14-.515 1.14-1.147s-.512-1.146-1.14-1.146m0 4.36c-1.762 0-3.195-1.441-3.195-3.214 0-1.772 1.433-3.214 3.195-3.214 1.763 0 3.196 1.442 3.196 3.214 0 1.773-1.433 3.215-3.196 3.215M51 55.27c-.628 0-1.14.514-1.14 1.147 0 .631.512 1.145 1.14 1.145a1.145 1.145 0 1 0 0-2.293m0 4.361c-1.762 0-3.196-1.442-3.196-3.213 0-1.773 1.434-3.215 3.196-3.215 1.762 0 3.196 1.442 3.196 3.215 0 1.771-1.434 3.213-3.196 3.213M30.283 35.968h2.055V33.21h-2.055zM35.205 35.968h2.056V33.21h-2.056zM40.127 35.968h2.056V33.21h-2.056zM45.05 35.968h2.055V33.21H45.05zM49.972 35.968h2.056V33.21h-2.056zM54.895 35.968h2.055V33.21h-2.055zM59.817 35.968h2.056V33.21h-2.056zM64.74 35.968h2.055V33.21h-2.056zM69.662 35.968h2.055V33.21h-2.055z',
                    fill: '#555',
                    mask: 'url(#b)'
                }),
                _react2.default.createElement(
                    'g',
                    {
                        fill: '#555'
                    },
                    _react2.default.createElement('path', {
                        d: 'M44.129 29.167h2.055V0H44.13zM56.286 29.167h2.055V0h-2.055z'
                    })
                )
            )
        )
    );
};

PelletStoveIcon.defaultProps = {
    width: '130',
    height: '130',
    viewBox: '0 0 130 130',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};

var PelletStove = function (_React$Component) {
    _inherits(PelletStove, _React$Component);

    function PelletStove() {
        _classCallCheck(this, PelletStove);

        return _possibleConstructorReturn(this, (PelletStove.__proto__ || Object.getPrototypeOf(PelletStove)).apply(this, arguments));
    }

    _createClass(PelletStove, [{
        key: 'render',
        value: function render() {

            var size = (0, _helpers2.default)(this.props.size || "medium", this.props.type, this.props.screenSize);

            return _react2.default.createElement(PelletStoveIcon, { width: size.width + 'px', height: size.height + 'px' });
        }
    }]);

    return PelletStove;
}(_react2.default.Component);

exports.default = PelletStove;